import React from 'react'
import Forms from '../components/Forms'

export default function PopForm() {
  return (
    <>
      <section className="popForm">
    <div className="container-fluid">
        <div className="row">
            <div className="col-md-12 p-0">
                  <picture>
                    <source media="(max-width:650px)" srcSet="assets/img/pop-form-bg-m.jpg" />
                    <img src="assets/img/pop-form-bg.jpg" alt=""/>
                  </picture>

                <div className="formBox">
                    <h2>Didn't spot what you had in mind?</h2>
                    <p>Engage with our specialists for optimal itineraries and exclusive offers!</p>
                    <button type="button" className="connectCta" data-bs-toggle="modal" data-bs-target="#popForm">Connect Now</button>
                </div>
            </div>
        </div>
    </div>
</section>

<div className="modal fade popupForm" id="popForm" tabIndex="-1" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered modal-xl">
      <div className="modal-content">
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        <div className="modal-body">
             <div className="row">
                
                <div className="col-md-8">
                <div className="lft">
                    <img src="assets/img/pop-form.png" alt=""/>
                    <h3>What's your next destination?</h3>
                    <p>Let's update your information to move forward.</p>
                </div>
                </div>
                <div className="col-md-4">
                <Forms submitBtnName="Update Now" formsource="Pop up Form"/>
            </div>
             </div>

            
        </div>
        
      </div>
    </div>
  </div>
    </>
  )
}
